
import { Paragraph, Spacer, TextCommon } from '@esg/ui';
import React from 'react';
import { ServiceInitCreate } from '@esg/business-account';
import { translateCodes } from '@/locales';

export const ServiceDeleteConfirm = ({ item }: { item: ServiceInitCreate; }) => {

    return (
        <Spacer top='xs'>
            <Paragraph fontSize={18} fontWeight={700}>
                <TextCommon translateCode={translateCodes.DELETE_SERVICE_TITLE} />
            </Paragraph>
            <Spacer type='margin' top={8} />
            <Paragraph>
                <TextCommon translateCode={translateCodes.DELETE_SERVICE_CONFIRM_MESSAGE} />:
                <TextCommon fontWeight={700}>
                    {' ' + item?.name}
                </TextCommon>
            </Paragraph>
        </Spacer>
    );
};
